(ns dre.components.platform-toolbar.views
  (:require
   [dre.app.events :as-alias app]
   [dre.components.main-nav.views :refer [main-nav]]
   [dre.components.platform-switcher.views :refer [platform-switcher
                                                   platform-dropdown]]
   [dre.components.searchbar.main-searchbar :refer [main-searchbar]]
   [dre.components.user-menu.views :refer [user-menu]]
   [dre.pages.events :as-alias pages]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]
   [reagent.core :as r]))


(def component-name :platform-toolbar)


(defn dre-logo
  []
  [:a.hidden-lg-down
   {:href "https://platform.doctorevidence.com/"}
   [:svg [:use {:href "#dre-logo"}]]])


(defn toolbar
  [_page-id _user]
  (let [searchbar-ref (r/atom nil)]
    (r/create-class
     {:component-did-mount
      (fn [this]
        (.click @searchbar-ref))
      :reagent-render
      (fn [page-id user]
        [:div
         {:class [component-name (bem/bm component-name :common)]}
         [:div
          {:class (bem/be component-name :logo)}
          [dre-logo]]
         [:div
          {:class (bem/be component-name :platform)}
          [platform-switcher user]
          [platform-dropdown user]
          [user-menu user]]
         [:div
          {:class (bem/be component-name :searchbar)}
          [main-searchbar {:db-root-path [:search]
                           :searchbar-ref searchbar-ref}]]
         [:div
          {:class (bem/be component-name :main-nav)}
          [main-nav page-id]]])})))

(defn toolbar-launch-page
  [_page-id user]
  [:div
   {:class [component-name (bem/bm component-name :launch)]}
   [:div
    {:class (bem/bem component-name :logo :launch)}
    [dre-logo]]
   [:div
    {:class (bem/bem component-name :platform :launch)}
    [platform-switcher user]
    [platform-dropdown user]]
   [:div
    {:class (bem/bem component-name :user-menu :launch)}
    [user-menu user]]])

(defn view
  []
  (let [page-id @(rf/subscribe [::pages/current-page-id])
        user @(rf/subscribe [::app/user])]
    (if (= page-id :frontpage)
      [toolbar-launch-page page-id user]
      [toolbar page-id user])))
